import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {isPresent} from '../../../../../shared/utils/lang';
import {Chart, ChartData} from '../../key-metrics.interfaces';
import {KeyMetricsTable} from '../../key-metrics.table';
import {ChartAbstract} from '../chart';

export abstract class Column extends ChartAbstract {

  protected constructor(chart: Chart,
                        translate: TranslateService,
                        localization: LocalizationService) {
    super(chart, translate, localization);
    this.categories = this.sortCategories(this.getCategories());
  }

  public createLoadView(withTitle: boolean, withLabel: boolean): void {
    super.createLoadView(withTitle, withLabel);

    if (withLabel) {
      this.series.forEach((value: any) => {
        value.itemStyle = {
          normal: {
            label: {
              show: true,
              formatter: (value) => isPresent(value.value)
                ? this.localization.localizeNumber(Math.abs(value.value), 'DECIMAL_2_DIGIT')
                : ''
            }
          }
        };
      });
    }
    this.createChart();
  }

  public resetChart(): void {
    this.series.forEach((value: any) => {
      value.itemStyle = {
        normal: {
          label: {
            show: false
          }
        }
      };
    });
    super.resetChart();
  }

  public generateTornadoTable(dataAccus1: ChartData[], dataAccus2: ChartData[]): void {
    const rowHeaders: string[] = this.series
      .map((seriesValue: any) => this.translate.instant(seriesValue.name));
    let colHeaders: string[] = [];
    let columns: string[] = [];
    let data: any[] = [];

    if (this.chart.time) {
      colHeaders = [...this.yAxis[0].data];
      columns = [...this.yAxis[0].data];
      data = this.series
        .map((seriesValue: any) => seriesValue.data
          .map((seriesData: number) => this.localization.localizeNumber(Math.abs(seriesData), 'DECIMAL_2_DIGIT')));
      this.table = new KeyMetricsTable(rowHeaders, colHeaders, columns, data);
    } else {
      dataAccus1.forEach((value: ChartData, index: number) => {
        colHeaders.push(this.translate.instant(value.category));
        columns.push(value.category);
        data.push(this.localization.localizeNumber(Math.abs(value.value), 'DECIMAL_2_DIGIT'));

        if (dataAccus2[index]) {
          colHeaders.push(dataAccus2[index].category);
          columns.push(dataAccus2[index].category);
          data.push(this.localization.localizeNumber(Math.abs(dataAccus2[index].value), 'DECIMAL_2_DIGIT'));
        }
      });
      this.table = new KeyMetricsTable(rowHeaders, colHeaders, columns, [data]);
    }
  }
}
